import React, { useRef } from 'react';
import {
  useTiptapEditor,
  WebEditor,
  WebEditorElement,
} from '@companycam/tiptap-editor';
import styled from 'styled-components';

import { PageTemplateObject } from 'data/v3/data-contracts';

const TipTapContainer = styled.div`
  margin: 0 var(--cc_size_spacing_l);
  padding-bottom: var(--cc_size_spacing_l);
  margin-top: var(--cc_size_spacing_l);
  flex: 1;
`;

type ExamplePageContent = {
  title: string;
  tiptapContent: PageTemplateObject['tiptapContent'];
};

type PreviewContentProps = {
  pageTemplate: PageTemplateObject | ExamplePageContent;
};

const ReadOnlyTipTap = ({ pageTemplate }: PreviewContentProps) => {
  const webEditorRef = useRef<WebEditorElement | null>(null);

  const { editor: tiptapEditor } = useTiptapEditor({
    editable: false,
    initialContent:
      pageTemplate?.tiptapContent?.content?.length > 0
        ? pageTemplate.tiptapContent
        : null,
  });

  return (
    <TipTapContainer data-testid="page-modal__body">
      <WebEditor
        title={pageTemplate.title}
        editor={tiptapEditor}
        ref={webEditorRef}
        isLightGalleryEnabled
      />
    </TipTapContainer>
  );
};

export default ReadOnlyTipTap;
